import { CardContent, Grid, Table, TableBody, TableHead, TableRow, TablePagination } from '@mui/material'
import TableHeadCell from 'components/TableHeadCell'
import AcademicYearItem from './Item'
import { useDispatch, useSelector } from 'react-redux'
import { search } from 'store/provider/academic-year'
import _ from 'lodash'
import { ROWS_PER_PAGE_OPTIONS } from 'constants'
import { useTranslation } from 'react-i18next'

export default function AcademicYearList() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { query, rows, count } = useSelector(state => state.provider.academicYear)

  const handleChangePage = (event, page) => {
    const limit = query?.limit || 10
    dispatch(search({ ...query, limit, offset: limit * page }))
  }

  const handleChangeRowsPerPage = event => {
    const limit = event.target.value
    dispatch(search({ ...query, offset: 0, limit }))
  }

  const rowsPerPageOptions = _.uniq([query?.limit || ROWS_PER_PAGE_OPTIONS]);


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell>{t('ID')}</TableHeadCell>
                <TableHeadCell>{t('Name')}</TableHeadCell>
                <TableHeadCell>{t('Type')}</TableHeadCell>
                <TableHeadCell>{t('Start Date')}</TableHeadCell>
                <TableHeadCell>{t('End Date')}</TableHeadCell>
                <TableHeadCell>{t('Actions')}</TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map(item => {
                return <AcademicYearItem key={item.id || item.uid} item={item} />
              })}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={count || 0}
            page={query?.limit ? query?.offset / query?.limit : 0}
            onPageChange={handleChangePage}
            rowsPerPage={query?.limit || 10}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
          />
        </CardContent>
      </Grid>
    </Grid>
  )
}
